/*
 * Copyright (C) 2015 - 2018 Kosmos contact@kosmos.fr
 *
 * Projet: ofin-webapp-contrib
 * Version: 7.1.0
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *         http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Created by alexandre.baillif on 13/12/16.
 */
(function() {
    'use strict';

    var datas = [];

    function getClosestParent(child) {
        var parent;
        while (child && child.parentNode && !parent) {
            child = child.parentNode;
            if (child.className && child.className.indexOf('js-editable-parent') > 0) {
                parent = child;
            }
        }
        return parent;
    }

    var toggleTarget = function (evt) {
        evt.preventDefault();
        evt.stopPropagation();
        var currentButton = this;
        var parentElt = getClosestParent(currentButton);
        var hideableValue = parentElt.querySelector('.js-editable-value');
        var showableField = parentElt.querySelector('.js-editable-element');
        hideableValue.classList.add('masquer');
        showableField.classList.remove('masquer');
    };

    var modifyButtons = document.querySelectorAll('.js-editable-button');

    [].forEach.call(modifyButtons, function(currentButton) {
        currentButton.addEventListener('click',toggleTarget);

    });

})();